export const TwoFAUrls = {
  verifyPassword: '/api/v1/verify-password',
  getTwoFACode: '/api/v1/get-2fa-code',
  updateTwoFAStatus: '/api/v1/change-2fa-status',
  cancel2FA: '/api/v1/cancel-2fa',
  verify2FACode: '/api/v1/verify-2fa-code',
  loginWith2FACode: '/api/v1/verify-2fa-code-login',
}
